import React from 'react';

import { useInfo } from '@/hooks/useInstanceFlag';
import { cn } from '@/utils/tailwind';

export interface VersionProps {
  className?: string;
}

export const Version: React.FC<VersionProps> = ({ className }) => {
  const { data: info, isLoading } = useInfo();

  if (isLoading || !info?.version) {
    return null;
  }

  return (
    <div
      className={cn(
        'inline-block rounded-full bg-tertiary px-2 py-1 text-[11px] font-medium text-quaternary',
        className
      )}
    >
      Version {info.version}
    </div>
  );
};
